// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { LocalStorage } from "services";
import { Wrapper } from "components";
import { Grid, Header, Transition, Icon } from "semantic-ui-react";

import "./Dashboard.scss";

type Props = {
    consumers: any,
    match: any,
};

type State = {
    visible: boolean,
    header: boolean,
    footer: boolean,
    authorizedParts: Array<string>,
    uid?: string,
    organizationId?: string,
    issuer: string,
};

/**
 * Dashboard
 * @author Tomasz tpr@deltacode.fr
 * @memberof Containers
 * @extends {React.Component}
 * @description Dashboard container
 */
class Dashboard extends Component<Props, State> {
    /**
     * @constructor
     * @param { Object } props Props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            authorizedParts: [],
            visible: false,
            header: false,
            footer: false,
        };
    }

    async componentDidMount() {
        /**
         * @instance
         * @memberof Containers.Dashboard
         * @method componentDidMount
         * @return { Void }
         */
        const authorizedParts = await LocalStorage.getItem("authorizedParts");
        const uid = await LocalStorage.getItem("uid");
        const organizationId = await LocalStorage.getItem("organizationId");
        const issuer = await LocalStorage.getItem("issuer");
        const header = await LocalStorage.getItem("header");
        const footer = await LocalStorage.getItem("footer");

        await this.setState({
            visible: true,
            authorizedParts: authorizedParts,
            header: header === "true" ? true : false,
            footer: footer === "true" ? true : false,
            uid: uid,
            organizationId: organizationId,
            issuer: issuer,
        });
    }

    render() {
        /**
         * @instance
         * @method render
         * @memberof Containers.Dashboard
         * @return { String } JSX
         */
        const {
            visible,
            authorizedParts,
            uid,
            organizationId,
            issuer,
        } = this.state;
        let colNumber;
        if (
            uid &&
            organizationId &&
            issuer === "hub" &&
            authorizedParts.includes("entreprises")
        ) {
            colNumber = 2;
        } else if (
            !(uid && organizationId && issuer === "hub") &&
            authorizedParts.includes("entreprises")
        ) {
            colNumber = 3;
        } else if (
            uid &&
            organizationId &&
            issuer === "hub" &&
            !authorizedParts.includes("entreprises")
        ) {
            colNumber = 3;
        } else {
            colNumber = 2;
        }
        return (
            <Grid className="Dashboard page bg-gradient">
                <Grid.Row>
                    <Grid.Column>
                        <Transition
                            visible={visible}
                            animation="fade up"
                            duration={500}
                        >
                            <Header
                                as="h2"
                                textAlign="center"
                                className="lead"
                                style={{
                                    marginTop: this.state.header ? "1rem" : 0,
                                }}
                            >
                                Quelles CCN <br />
                                pour quelles entreprises ?
                            </Header>
                        </Transition>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row
                    style={{ marginTop: this.state.header ? "-1rem" : "-2rem" }}
                >
                    <Grid.Column>
                        <Grid stackable columns={colNumber}>
                            <Grid.Row>
                                <Grid.Column>
                                    <Link
                                        className="link medium center"
                                        to="/recherche/ccn"
                                    >
                                        <Wrapper
                                            style={{
                                                textAlign: "center",
                                            }}
                                        >
                                            <Icon
                                                circular
                                                name="search"
                                                size="large"
                                            />
                                        </Wrapper>
                                        <Wrapper
                                            style={{
                                                textAlign: "center",
                                            }}
                                        >
                                            Les obligations{" "}
                                            <span className="color-default-light">
                                                par CCN
                                            </span>
                                        </Wrapper>
                                    </Link>
                                </Grid.Column>
                                {authorizedParts.includes("entreprises") && (
                                    <Grid.Column>
                                        <Link
                                            className="link medium center"
                                            to="/recherche/entreprises"
                                        >
                                            {" "}
                                            <Wrapper
                                                style={{
                                                    textAlign: "center",
                                                }}
                                            >
                                                <Icon
                                                    circular
                                                    name="building"
                                                    size="large"
                                                />
                                            </Wrapper>
                                            <Wrapper
                                                style={{
                                                    textAlign: "center",
                                                }}
                                            >
                                                Recherche{" "}
                                                <span className="color-default-light">
                                                    d'Entreprises
                                                </span>
                                            </Wrapper>
                                        </Link>
                                    </Grid.Column>
                                )}
                                <Grid.Column>
                                    <Link
                                        className="link medium center"
                                        to="/filtre"
                                    >
                                        <Wrapper
                                            style={{
                                                textAlign: "center",
                                            }}
                                        >
                                            <Icon
                                                circular
                                                name="filter"
                                                size="large"
                                            />
                                        </Wrapper>
                                        <Wrapper
                                            style={{
                                                textAlign: "center",
                                            }}
                                        >
                                            Filtrer{" "}
                                            <span className="color-default-light">
                                                les CCN
                                            </span>
                                        </Wrapper>
                                    </Link>
                                </Grid.Column>
                                {uid && organizationId && issuer === "hub" && (
                                    <Grid.Column>
                                        <Link
                                            className="link medium center"
                                            to="/favoris"
                                        >
                                            {" "}
                                            <Wrapper
                                                style={{
                                                    textAlign: "center",
                                                }}
                                            >
                                                <Icon
                                                    circular
                                                    name="star"
                                                    size="large"
                                                />
                                            </Wrapper>
                                            <Wrapper
                                                style={{
                                                    textAlign: "center",
                                                }}
                                            >
                                                Mes{" "}
                                                <span className="color-default-light">
                                                    favoris
                                                </span>
                                            </Wrapper>
                                        </Link>
                                    </Grid.Column>
                                )}
                                <Grid.Column>
                                    <Link
                                        className="link medium center"
                                        to="/articles"
                                    >
                                        {" "}
                                        <Wrapper
                                            style={{
                                                textAlign: "center",
                                            }}
                                        >
                                            <Icon
                                                circular
                                                name="book"
                                                size="large"
                                            />
                                        </Wrapper>
                                        <Wrapper
                                            style={{
                                                textAlign: "center",
                                            }}
                                        >
                                            Lexique{" "}
                                            <span className="color-default-light">
                                                CCN
                                            </span>
                                        </Wrapper>
                                    </Link>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

export { Dashboard };
